const Notfound =() => {
    return(
        <>
        <h1> Not found </h1>
        </>
       
    )
}
export default Notfound;